export default __webpack_public_path__ + "locales/pl/Profile.json?hash=3eb03d7a89b8f6bd98b760d8bc081ee5";